import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=50afbf02&scoped=true&"
import script from "./Agreements.vue?vue&type=script&lang=js&"
export * from "./Agreements.vue?vue&type=script&lang=js&"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=50afbf02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afbf02",
  null
  
)

export default component.exports